import { ErrorResponseContentInterface } from '@systemeio/util'
import React from 'react'
import { SafeHtmlText, toast } from 'shared/components'

export const handleOfferPricePlansErrors = (
  errors: ErrorResponseContentInterface<{
    offerPricePlans?: string[]
    bumps?: [{ offerPricePlans?: string[] }] | [[string]]
    coupons?: string[]
  }>,
) => {
  const getErrorMessage = () => {
    const { offerPricePlans, bumps, coupons } = errors.fields

    if (offerPricePlans) return offerPricePlans
    if (coupons) return coupons

    const firstElement = bumps?.[0]
    if (firstElement) {
      return Array.isArray(firstElement) ? firstElement : firstElement.offerPricePlans
    }

    return errors.common
  }

  const errorMessage = getErrorMessage()?.join(', ')

  if (!errorMessage) return

  toast.error(<SafeHtmlText html={errorMessage} />)
}
